<template>
  <div class="link">
    <router-link :to="getStoryblokLink(menuItem.link)" v-html="menuItem.title"></router-link>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
